import Errors from './Errors' ;

export default class Form {

    constructor(data, clearForm = true) {

        this.clearForm = clearForm
        this.originalData = data;
        this.isSubmitted = false;
        this.usingFiles = false

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    withFiles(){
        this.usingFiles = true;
        return this
    }

    clearFormAfterSuccessResponse(status){
        this.clearForm = status;
    }

    dontClear() {
        this.clearForm = false;
        return this
    }

    data(method) {

        if(this.usingFiles) {
            return this.buildFormFileData(method)
        }

        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    buildFormFileData(method) {

        let data = new FormData();

        for (let property in this.originalData) {

            var value = this[property];

            if (typeof value === "boolean") {
                value = (value === true) ? 1 : 0;
            }

            data.append(property, value);
        }

        if (method == 'delete' || method == 'patch' || method == 'put') {
            data.append('_method', method);
        }

        return data;
    }

    reset() {
        if(this.clearForm) {
            for (let field in this.originalData) {
                if(Array.isArray(this[field])){
                    this[field] = [];
                }else{
                    this[field] = '';
                }
            }
        }
        this.errors.clear();
    }

    get(url){
        return this.submit('get', url);
    }

    post(url) {
        return this.submit('post', url);
    }

    put(url) {
        return this.submit('put', url);
    }

    patch(url) {
        return this.submit('patch', url);
    }

    delete(url) {
        return this.submit('delete', url);
    }

    submit(requestType, url) {
        this.isSubmitted = true;
        var method = requestType;
        requestType = this.usingFiles ? 'post' : requestType;
        return new Promise((resolve, reject) => {
                App.request()[requestType](url, this.data(method))
                    .then(response => {
                        this.onSuccess(response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                         this.onFail(error.response.data);
                         reject(this.errors);
                    });
        });
    }

    onSuccess(data) {
        this.isSubmitted = false;
        this.reset();
    }

    onFail(errors) {
        this.isSubmitted = false;
        var errorsBad = errors.hasOwnProperty('errors') ? errors.errors : {};
        this.errors.record(errorsBad, errors.message, errors.exception);
    }
}
